import {
  Directive, OnInit, OnChanges, OnDestroy, SimpleChanges, HostListener, Injector, Input
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BindingData, BindingList, Change, ChangeType, ViewModel, FrameContext } from '@farris/devkit';
import { AppointmentCalendarComponent } from '@farris/appointment-calendar';
import { BefRestService, BefRepository, ViewType } from './types';
import { isEqual } from 'lodash-es';
import { BasePathService } from '@farris/rtf';

@Directive({
  selector: '[farris-appointment-calendar-binding]'
})
export class AppointmentCalendarBindingDirective implements OnInit, OnChanges, OnDestroy {
  private __DATA__: any;
  private bindingDataChangeEvent: Subscription;
  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }
  private get viewModel(): ViewModel {
    return this.frameContext.viewModel;
  }
  private restService(): BefRestService {
    return (this.frameContext.repository as BefRepository).restService;
  }
  /**
   * è·åç»å®æ°æ®
   */
  protected get bindingList(): BindingList {
    // æ ¹å®ä½
    if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
      return this.bindingData.list;
    }
    // å­å®ä½
    let bindingPath = this.viewModel.bindingPath.substr(1);
    bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
    const paths = bindingPath.split('/');

    const filteredPaths = paths.filter((part: string) => {
      return part !== '';
    });
    return this.bindingData.getValue(filteredPaths);
  }
  /**
   * æ¿é´åè¡¨api url
   */
  @Input() url: string = null;
  /**
   * http method, default PUT
   */
  @Input() method: string = 'PUT';
  @Input() startDateVariable: string = 'startDate';
  @Input() endDateVariable: string = 'endDate';
  @Input() viewTypeVariable: string = 'viewType';

  constructor(private injector: Injector, private frameContext: FrameContext, private calendarComponent: AppointmentCalendarComponent) { }

  ngOnInit(): void {
    this.loadPlacements();
    this.registerBindingDataChangeEvent();
  }
  ngOnChanges(changes: SimpleChanges): void {

  }
  ngOnDestroy(): void {
    this.unRegisterBindingDataChangeEvent();
  }
  private bindData(change: Change) {
    // åtoJSON
    let data: any = this.bindingList.toJSON();
    if (this.__DATA__ && isEqual(this.__DATA__, data)) {
      return;
    }
    this.__DATA__ = data;
    this.calendarComponent.loadReserveData(data);
  }
  private onBindingDataChange(change: Change) {
    this.bindData(change);
    this.updateSelectedRow(change);
  }
  private registerBindingDataChangeEvent() {
    this.bindingDataChangeEvent = this.bindingData.changes.subscribe((change: Change) => {
      this.onBindingDataChange(change);
    });
  }
  /**
   * åæ¶bindingdataååè®¢é
   */
  private unRegisterBindingDataChangeEvent() {
    if (this.bindingDataChangeEvent && typeof (this.bindingDataChangeEvent.unsubscribe) === 'function') {
      this.bindingDataChangeEvent.unsubscribe();
    }
  }
  private loadPlacements() {
    if (!this.url) {
      console.log('æ æ³å è½½æ¿é´ä¿¡æ¯ï¼è¯·éç½®æ¿é´åè¡¨apiå°å');
      return;
    }
    const requestInfo = this.restService().buildRequestInfo();
    const options = {
      body: {
        requestInfo
      }
    };
    const url = BasePathService.convertPath(this.url);
    this.restService().request(url, this.method, null, options).subscribe((returnValue: any) => {
      this.bindPlacements(returnValue);
    });
  }
  private bindPlacements(placments: any) {
    this.calendarComponent.loadPlaceData(placments);
  }
  private updateState(startDate: string, endDate: string, viewType: string) {
    this.viewModel.uiState.setPropertyValue(this.startDateVariable, startDate);
    this.viewModel.uiState.setPropertyValue(this.endDateVariable, endDate);
    this.viewModel.uiState.setPropertyValue(this.viewTypeVariable, viewType);
  }
  private updateSelectedRow(change?: Change) {
    if (!this.bindingList || !this.bindingList.currentId) {
      return;
    }
    // é¡µç åæ¢æ¶ä¸æ§è¡å½åè¡åæ¢
    if (change && change.type === ChangeType.PaginationInfoChange) {
      return;
    }
    if (this.viewModel && this.viewModel.frameContext.bindingData.rowSelectedEventSuspend === true) {
      return;
    }
    const id = this.calendarComponent.selectedId;
    const currentId = this.bindingList.currentId;
    // gridå½åè¡ä¸bingingListå½åè¡ä¸è´ï¼æ é¡»åæ¢
    if (id === currentId) {
      return;
    }
    this.selectCalendarRow(this.bindingList.currentId);
  }
  private selectCalendarRow(id: string) {
    this.calendarComponent.selectItem(id);
  }
  @HostListener('filterChange', ['$event'])
  public filterChanged(event: any) {
    const { dateValue = null, place = null, viewType = null } = event || {};
    let startDate = null;
    let endDate = null;
    if (!dateValue) {
      return;
    }
    if (viewType === ViewType.day) {
      startDate = `${dateValue} 00:00:00`;
      endDate = `${dateValue} 23:59:59`;
    } else if (viewType === ViewType.week && dateValue.indexOf('~') !== -1) {
      const sections = dateValue.split('~');
      startDate = `${sections[0]} 00:00:00`;
      endDate = `${sections[1]} 23:59:59`;
    }
    this.updateState(startDate, endDate, viewType);
  }
  protected setSelectionIdToBindingData(id: string): void {
    // å¦æå½åè¡ä¸å­å¨ï¼åå¼ºå¶è®¾ç½®
    if (this.bindingList.currentId !== id) {
      this.bindingList.setCurrentId(id, true);
    }
  }
  @HostListener('selectChange', ['$event'])
  public selectChange(event) {
    const { item: { id = null } } = event;
    this.setSelectionIdToBindingData(id);
  }
}
